import { Link } from "react-router-dom";
import { categories } from "@/mocks/posts";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-50 border-b border-background-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <SectionHeading
          eyebrow="主题分类"
          title="按你关心的方向逛"
          desc="从明星动态到网络热梗，六个常驻栏目覆盖日常吃瓜的主要方向，每类都有独立入口。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/breaking?cat=${cat.slug}`}
              className="group flex items-start gap-4 p-5 rounded-lg border border-background-200 bg-background-100 hover:border-secondary-400 hover:bg-background-50 transition-colors cursor-pointer"
            >
              <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                <i className={`${cat.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <span className="flex-1 min-w-0">
                <span className="flex items-center justify-between gap-2">
                  <span className="font-heading font-bold text-base text-foreground-950">{cat.name}</span>
                  <i
                    className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-600 transition-colors"
                    aria-hidden="true"
                  ></i>
                </span>
                <span className="mt-1.5 block text-sm text-foreground-600 leading-relaxed">{cat.desc}</span>
                <span className="mt-3 inline-block text-xs text-foreground-500">累计 {cat.count} 条内容</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}